import { Container, Box, Header } from "@amzn/awsui-components-react/polaris";
import {USE_CASE_CONFIG, FILING_CONFIG} from "../utils/Constants"

//TODO : create API to fetch available use-cases
export function getDropdownItems() {
    return USE_CASE_CONFIG;
}

export const getFilingInstruction = (useCase) => {
    const instruction  = useCase ? FILING_CONFIG[useCase]?.instructions : null;
    if(instruction){
        return (
            <Container>
                <Header variant="h3">Instructions</Header>
                {instruction.map(function(data,idx){
                    return (<li key={idx}>{data}</li>)
                })}
            </Container>
          ); 
    }
}

export let fetchCountry = (useCase) => {
    if (useCase === "FR")
        return "FRANCE";
    else if (useCase === "NOR")
        return "NORWAY";
    else if (useCase === "AU")
        return "AUSTRIA";
    else if (useCase === "SA")
        return "SOUTH AFRICA"
    else if (useCase === "IT")
        return "ITALY"
    else if (useCase === "DE")
        return "GERMANY"
    else if (useCase === "LUX")
        return "LUXEMBOURG"
    else if (useCase === "PL")
        return "POLAND"
    else if (useCase === "UK_VAT_FILING")
        return "UK_VAT_FILING";
    else if (useCase === "IS_VAT_FILING")
        return "IS_VAT_FILING";
    else if (useCase === "DE_INTRASTAT_FILING")
        return "DE_INTRASTAT_FILING";
    else if (useCase === "IR_MOSS_FILING")
        return "IR_MOSS_FILING";
    else if (useCase === "DE_VAT_FILING")
        return "DE_VAT_FILING";
    else if (useCase === "TR_DST_FILING")
        return "TR_DST_FILING";
    else if (useCase === "TR_VAT_FILING")
        return "TR_VAT_FILING";
    else if (useCase === "SA_VAT_FILING")
        return "ZA_VAT_FILING";
    else if (useCase === "TH_VAT_FILING")
        return "TH_VAT_FILING";
    else if (useCase === "CA_DST_FILING")
        return "CA_DST_FILING";
    else if (useCase === "IN_TDS_FILING")
        return "IN_TDS_FILING";
    else if (useCase === "SK_VAT_FILING")
        return "SK_VAT_FILING";
    else
        return "Compliance";
}

/** "N/M filings have errors." from the audit record's additionalDataMap counts. */
export const generateErrorDetailsMessage = (additionalDataMap) => {
    if (additionalDataMap?.totalTransactions && additionalDataMap?.successfulTransactions != null) {
        const totalTransactions = additionalDataMap.totalTransactions;
        const successfulTransactions = additionalDataMap.successfulTransactions;
        return `${totalTransactions - successfulTransactions}/${totalTransactions} filings have errors.`;
    }
    return 'Some filings have errors';
};

/** Transaction statuses that have something to report in Error Details. */
export const STATUSES_WITH_ERRORS = ["FAILURE", "EXCEPTION", "PARTIAL_SUCCESS", "ERROR"];

/** True when the audit record has both the key and the bucket of its input file. */
export const hasTransactionInputFile = auditRow =>
    Boolean(auditRow?.inputFileKey && auditRow?.inputFileBucket);

/** Recorded errorDetails if any; otherwise the counts summary for an error status; otherwise null. */
export const resolveTransactionErrorDetails = auditRow => {
    if (auditRow?.errorDetails) {
        return auditRow.errorDetails;
    }
    if (STATUSES_WITH_ERRORS.includes(auditRow?.status)) {
        return generateErrorDetailsMessage(auditRow?.additionalDataMap);
    }
    return null;
};

export const STATUSES_IN_PROGRESS = ["PROCESSING"];

export const isTransactionInProgress = auditRow =>
    STATUSES_IN_PROGRESS.includes(auditRow?.status);

/** Last path segment of an S3 key, or null when the key is missing or ends in a folder. */
export const getFileNameFromS3Key = s3Key => {
    const segments = String(s3Key ?? "").split("/");
    const fileName = segments[segments.length - 1];
    return fileName || null;
};

/** Display name of an Excalibur record's generated report, as the Excalibur table shows it. */
export const getGeneratedReportName = auditRow => {
    if (!auditRow?.documentId) {
        return null;
    }
    const inputBaseName = getFileNameFromS3Key(auditRow.inputFileKey)?.split(".")[0];
    return inputBaseName ? `${inputBaseName}_${auditRow.documentId}` : auditRow.documentId;
};

// Cut long float values update X decimal places
export const convertToXDecimalPlaces = (num, digits) => {
    if (typeof num == 'number' && !isNaN(num) && !Number.isInteger(num)) {
        return parseFloat(num.toFixed(digits))
    }
    return num
}

export const getStartEndDateOfFiscalYear = () => {
    let today = new Date();

    // start date = today - 1 year
    let date = new Date(today);
    date.setFullYear(date.getFullYear()-1);
    date.setDate(date.getDate()+1);
    let startDate = date.toISOString().split('T')[0];

    let endDate = today.toISOString().split('T')[0];
    return { startDate, endDate }
}

export const populateReportingPeriod = (data) => {
    if(!data || !data.length)
    return;
    let result = [];
    for (let i = 0; i < data.length; i++) {
        let text;
        if(data[i].status === "F"){
            text = data[i].startDate + " - " + data[i].endDate + " (FULFILLED)";
        } else {
            text = data[i].startDate + " - " + data[i].endDate
        }
        result.push({ id: i + 1, text: text, periodKey: data[i].periodKey, disabled: data[i].status === "F" })
    }
    return result;
}

export const ValueWithLabel = ({ label, children }) => (
    <div>
        <Box variant="awsui-key-label">{label}</Box>
        <div>{children}</div>
    </div>
)

export function getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes /= 1024;
      i++;
    } while (fileSizeInBytes > 1024);
  
    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  }
